export const de = {
  navigation: {
    map: "Karte",
    guessr: "Guessr",
  },
  home: {
    filters: "Filter",
    general: "Allgemein",
    filterItems: {
      FAST_TRAVEL: "Schnellreise",
      NEXT_CS: "Nächster Wettbewerb",
      GUESSR: "SSO Guessr Orte",
    },
    coordinates: "X: {x}, Y: {y}",
  },
  guessr: {
    title: "SSO Guessr",
    loading: "Lädt...",
    buttons: {
      guess: "Raten",
      next: "Weiter",
      again: "Noch einmal",
      leaveConfirm: "Das Spiel läuft noch. Möchtest du es wirklich verlassen?",
    },
    toasts: {
      zeroPoints: "😥 Überhaupt nicht... 0 Punkte",
      goodPoints: "👍 Nicht schlecht! Du erhältst {points} Punkte!",
      perfectPoints: "💕 PERFEKT! {points} PUNKTE!",
      fetchError: "Fehler beim Abrufen der Daten: {message}",
    },
    alt: {
      locationPhoto: "Standortfoto, rate wo es aufgenommen wurde",
      fullscreenPreview: "Vollbild-Fotovorschau",
      clickToEnlarge: "Klicken zum Vergrößern",
      tapToEnlarge: "Tippen zum Vergrößern",
    },
    result: {
      perfect: [
        "Herzlichen Glückwunsch! Du bist ein wahrer Standort-Meister!",
        "Perfektion! Dein Wissen über Jorvik ist beeindruckend.",
        "Außergewöhnliches Gedächtnis! Du hast einen tollen Blick für Details.",
        "Bravo! Du hast jeden Ort fehlerfrei erkannt!",
      ],
      almostPerfect: [
        "Fantastisch! Du bist fast ein Meister im Erkennen von Orten.",
        "Praktisch perfekt! Nur ein paar Details zu verbessern.",
        "Beeindruckend! Nur kleine Anpassungen trennen dich von der Perfektion.",
        "Großartig! Du bist auf einem sehr hohen Niveau.",
        "Es fehlt nicht viel für ein perfektes Ergebnis!",
      ],
      great: [
        "Gute Arbeit! Du bist fast ein Experte.",
        "Sehr nah dran! Ein paar kleine Anpassungen und du bist an der Spitze.",
        "Fühlst du dich sicher? Noch ein Moment und du bist der Beste!",
        "Sehr gut! Nur noch wenige Details zu verfeinern.",
      ],
      good: [
        "Nicht schlecht, aber du kannst es besser!",
        "Nah dran, aber noch etwas Arbeit vor dir.",
        "Ein paar Schritte vorwärts und du wirst ein Meister sein!",
        "Du kommst langsam in Fahrt. Mach weiter so!",
      ],
      sad: [
        "Das lief nicht sehr gut. Versuch es noch einmal!",
        "Schau dich in Jorvik um und komm erleuchtet zurück...",
        "Verirrst du dich mit so einem Gedächtnis nicht in deinem eigenen Haus?",
        "Oh je, das ist nicht das beste Ergebnis. Vielleicht läuft es beim nächsten Mal besser?",
        "Lass dich nicht entmutigen! Jeder Versuch bringt dich dem Ziel näher.",
        "Sieht so aus, als bräuchtest du noch etwas Übung.",
        "Keine Sorge, selbst die Besten haben bei Null angefangen!",
      ],
      points: "Du hast {points} von {maxPoints} möglichen Punkten erreicht!",
    },
    footer: {
      author: "Łukasz Skabowski",
      source: "Quellcode",
    },
  },
  time: {
    minutesSeconds: "in {minutes}min {seconds}s",
    seconds: "in {seconds}s",
  },
};
